import { useTheme } from "@mui/system";
import React, { useMemo } from "react";
import {
  AreaChart,
  XAxis,
  Area,
  ResponsiveContainer,
  YAxis,
  CartesianGrid,
} from "recharts";
import { toToman } from "../../utils/Utils";

const CustomYAxis = (props) => {
  const theme = useTheme();
  const { x, y, payload } = props;
  const stringPayload = `${toToman(payload.value)} تومان`;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        fill={theme.palette.grey[4]}
        textAnchor="end"
        x={0}
        style={{ direction: "rtl", fontSize: 12 }}
      >
        {stringPayload}
      </text>
    </g>
  );
};

const BalootAreaChart = (props) => {
  const { data } = props;
  const theme = useTheme();
  return (
    <ResponsiveContainer height={200}>
      <AreaChart
        data={data}
        margin={{ top: 32, right: 0, left: 0, bottom: 24 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="70%"
              stopColor={theme.palette.secondary.main}
              stopOpacity={0.2}
            />
            <stop
              offset="100%"
              stopColor={theme.palette.secondary.main}
              stopOpacity={0.0}
            />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="1 4"
          vertical={false}
          stroke={theme.palette.grey[5]}
        />

        <YAxis
          axisLine={false}
          tick={<CustomYAxis />}
          tickCount={4}
          domain={["auto", "auto"]}
          tickLine={false}
          mirror={true}
          tickMargin={0}
        />

        <Area
          type="monotone"
          dataKey="amount"
          stroke={theme.palette.secondary.main}
          strokeWidth={1}
          fillOpacity={0.8}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default BalootAreaChart;
